import React, {Component} from 'react';
import { Row, Col, Radio } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';

import TvSurveyRosace from '../../charts/TvSurveyRosace/TvSurveyRosaceComponent'
import ComparisonSimpleTooltip from '../JetpackComponents/ComparisonTooltip/ComparisonSimpleTooltip'
import Concepts from '../Concepts/Concepts'
import CitySelector from '../CitySelector/CitySelector'
import Text from '../Text/Text'

import surveySummary from '../../data/surveySummary2019.json'
import zigzag from '../../assets/images/pattern-zigzag.png'
import logo from '../../assets/images/visit-flanders-logo.png'
import jetpackLogo from '../../assets/images/JetpackAI-small.png'
import LanguageSwitch from '../LanguageSwitch/LanguageSwitch'

export const PARAM_ADVANCE_MODE = false;
export const PARAM_DETAIL_LEVEL = PARAM_ADVANCE_MODE ? 5 : 3; // SHOULD BE 3 OR 5

class SurveySummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltip: null,
      citySelection: 'all',
      cityStats: surveySummary['all'],
      linear: false,
      metric: 'agreementAbsolute',
      mainType: 'drivers',
      //mainType: 'support',
      selectedQuestion: null,
      advanceMode: false,
    };
  }

  componentDidMount() {
    //forced to do that in order to have a proper initial rendering of the text
    setTimeout(() => this.setState({ mainType: 'support' }), 300);
  }

  setTooltip = (data) => {
    this.setState({ tooltip: data });
  }

  selectMainType = (e) => {
    const mainType = e.target.value
    this.setState({ 
      mainType,
    })
  }

  setLinear = (checked) => {
    this.setState({ linear: checked})
  }

  onMetricChange = (e) => {
    this.setState({ metric: e.target.value });
  }
  
  onConceptSelection = (concept) => {
    this.setState({ mainType: concept })
  }

  onCitySelection = (city) => {
    this.setState({ 
      citySelection: city, 
      cityStats: surveySummary[city]
    })
  }

  setContext = (context) => {
    this.setState({...this.state, ...context}, () => {
      this.onCitySelection(context.citySelection)
    })
  }

  selectQuestion = (selectedQuestion) => {
    this.setState({...this.state, selectedQuestion: selectedQuestion === this.state.selectedQuestion ? null : selectedQuestion })
  }

  render() {
    const { intl, history } = this.props;
    const { locale } = intl;
    const { tooltip, citySelection, cityStats, linear, metric, mainType, selectedQuestion } = this.state;
    const cityStatsFiltered = cityStats
      //.filter(s => mainType === 'all' || s.mainType === mainType)
      .filter(concept => {
        if(mainType === 'support' || mainType === 'impact') {
          return concept.mainType === 'support' || concept.mainType === 'impact';
        } else {
          return concept.mainType === mainType;
        }
      })
    return (
      <div>
        <div>
          <Row type="flex" justify="space-between" align="middle">
            <h1 style={{ paddingLeft: 16 }}><FormattedMessage id="app.title"/> <span style={{ fontFamily: 'Flanders Art Sans' }}>| <FormattedMessage id="app.subTitle"/></span></h1>
            <LanguageSwitch history={history} />
          </Row>
          <div style={{ backgroundColor: '#FFE615', height: 8, width: '20%', marginBottom: 16 }} />  
        </div>
        {/*<SurveySummaryChart />*/}
        <Row style={{ background: `url(${zigzag})` }}>
          <Col xs={24} sm={24} md={14} lg={14} xl={14} style={{ position: 'relative' }}>
            <div style={{ position: 'absolute', top: '3%', left: '3%'}}>
              <img src={logo} style={{ width: '30%' }} alt='logo'/>
            </div>
            <div style={{ position: 'absolute', bottom: '2%', left: '3%'}}>
              <FormattedMessage id="app.designedBy"
                      defaultMessage="Designed by"/>
              {' '} <a href="http://jetpack.ai" target="blank"><img src={jetpackLogo} style={{ width: 130 }} alt='jetpackLogo'/></a>
            </div>
            <TvSurveyRosace 
              data={cityStatsFiltered} 
              metric={metric} 
              curved={false} 
              setTooltip={this.setTooltip} 
              linear={linear}
              city={citySelection}
              concept={mainType} 
              selectedQuestion={selectedQuestion}
              selectQuestion={this.selectQuestion}
              locale={locale}
            />
            <ComparisonSimpleTooltip tooltip={tooltip} city={citySelection}/>
          </Col>
          <Col xs={24} sm={24} md={9} lg={9} xl={9}>
            {/*<div><Switch onChange={this.setLinear} checked={linear} /> {linear ? 'Linear' : 'Round'}</div>*/}
            {PARAM_ADVANCE_MODE && (
              <div>
                <Radio.Group onChange={this.onMetricChange} value={metric}>
                  <Radio value="agreementAbsolute"><FormattedMessage id="app.agreementRatio" /></Radio>
                  <Radio value="average"><FormattedMessage id="app.averageScore" /></Radio>
                  {/*<Radio value="agreementRelative">% Agreeing (relative)</Radio>*/}
                </Radio.Group>
              </div>
            )}
            {/*<div>
              <Radio.Group onChange={this.selectCity} value={citySelection}>
                <Radio.Button value="Antwerpen">Antwerpen</Radio.Button>
                <Radio.Button value="Gent">Gent</Radio.Button>
                <Radio.Button value="Leuven">Leuven</Radio.Button>
                <Radio.Button value="Mechelen">Mechelen</Radio.Button>
                <Radio.Button value="Brugge">Brugge</Radio.Button>
              </Radio.Group>
            </div>
            <div>
              <Radio.Group onChange={this.selectMainType} value={mainType}>
                <Radio.Button value="all">All</Radio.Button>
                <Radio.Button value="support">Support</Radio.Button>
                <Radio.Button value="drivers">Drivers</Radio.Button>
                <Radio.Button value="impact">Impact</Radio.Button>
              </Radio.Group>
            </div>*/}
            <div style={{ paddingBottom: 16 }}>
              <div style={{ textAlign: 'center' }}>
                <Concepts selectedConcept={mainType} onConceptSelection={this.onConceptSelection}/>
              </div>
            </div>
            <div style={{ paddingBottom: 16 }}>
              <div style={{ textAlign: 'center' }}>
                <CitySelector selectedCity={citySelection} onCitySelection={this.onCitySelection}/>
              </div>
            </div>
            <div style={{ paddingBottom: 0 }}>
              <div style={{ height: 'calc(100vh - 320px)', overflowY: 'scroll', padding: 8, backgroundColor: '#ffffffee' }}>
                <Text setContext={this.setContext}/>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default injectIntl(SurveySummary);
